import OverlayCarousel, { Props } from '.';
import { BACKGROUND_COLORS, PHONE_COLORS } from '../../../../shared/colors';
import { BuilderConfig } from '../../../../types/Builder';

export const FlowCarouselOverlayBuilderConfig = {
  name: 'Flow Carousel Overlay',
  inputs: [
    {
      name: 'mode',
      type: 'string',
      defaultValue: 'center',
      enum: ['right', 'center'],
    },
    {
      name: 'phoneColor',
      type: 'string',
      defaultValue: PHONE_COLORS.MIDNIGHT,
      enum: Object.values(PHONE_COLORS),
    },
    {
      name: 'color',
      type: 'string',
      defaultValue: BACKGROUND_COLORS.MOSS_20,
      enum: Object.values(BACKGROUND_COLORS),
    },
    {
      name: 'header',
      type: 'object',
      subFields: [
        { name: 'category', type: 'string' },
        { name: 'number', type: 'string' },
        { name: 'url', type: 'url' },
      ],
    },
    {
      name: 'data',
      type: 'object',
      subFields: [
        { name: 'title', type: 'string' },
        { name: 'description', type: 'richText' },
        {
          name: 'items',
          type: 'list',
          defaultValue: [],
          subFields: [
            { name: 'name', type: 'richText', defaultValue: '' },
            { name: 'image', type: 'file', defaultValue: '' },
          ],
        },
      ],
    },
    {
      name: 'backgroundColor',
      type: 'string',
      defaultValue: BACKGROUND_COLORS.MOSS_20,
      enum: Object.values(BACKGROUND_COLORS),
    },
  ],
};

const builderConfig: BuilderConfig<Props> = {
  component: OverlayCarousel,
  config: FlowCarouselOverlayBuilderConfig,
};

export default builderConfig;
